
var $window = $(window);

page_home();

function page_home(){
	'use strict';
	// #page-home 以外は抜ける
	if( !$('#page-home').length ) return;

	resize_visual();
}

// ビジュアルのリサイズ
function resize_visual(){
    var $visual_pc_parent = $('.visual');
    var visual_pc = $('.visual__pc').get(0);

    function onResize(){
        var per = $visual_pc_parent.width() / 1200;

        // リサイズは transformのほうが早い
        var style = visual_pc.style;
        require('../caracol2/effect/transform_css.js').
            set_transform( style, 'scale('+per+')' );
    }

    // スマホの場合はリサイズ動作しない
    if( !$.isMobile ){
    	$window.on( 'resize', $.throttle(100, onResize) );
        setTimeout( onResize, 500);
    }

}




/*****************
 ** WEBPACK FOOTER
 ** ./js/page/page_home.js
 ** module id = 13
 ** module chunks = 0
 **/